import { useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState, useEffect, useRef } from "react";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";
import { uploadImageOnAWS } from "../../aws/Service";
import { add_blog } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from 'react-select';

const Editor = ({ content, onChange }) => {
    return (
        <ReactQuill
            value={content}
            onChange={onChange}
            modules={Editor.modules}
            formats={Editor.formats}
            theme="snow"
            placeholder="Write something..."
            style={{ borderRadius: '10px' }}
        />
    );
};

Editor.modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
    ],
};

Editor.formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
];

const panelOptions = [
    { label: 'Landing Page', value: 'landing_page' },
    { label: 'Teacher', value: 'teacher' },
    { label: 'Organization', value: 'organization' },
    { label: 'Organization Teacher', value: 'org_teacher' },
    { label: 'Parents', value: 'below_18' },
    { label: 'Kids', value: 'learner' },
    { label: 'Over 18', value: 'above_18' },
    { label: 'Schools-After School Centers', value: 'after_school' }
];

export default function AddBlog({ isLoader }) {
    const navigate = useNavigate();
    const [previewImageUrls, setPreviewImageUrls] = useState([]);
    const [previewVideoUrls, setPreviewVideoUrls] = useState([]);

    const [lessonDetails, setLessonDetails] = useState([{ title: '', description: '', link: '', attachment: null }]);
    const [AttachmentData, setAttachmentData] = useState({});

    const [selectedPanels, setSelectedPanels] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [panelError, setPanelError] = useState('');

    const AdminId = localStorage.getItem("aID");

    const handleSelectAllChange = (e) => {
        setSelectAll(e.target.checked);
        if (e.target.checked) {
            setSelectedPanels(panelOptions.map(o => o.value));
        } else {
            setSelectedPanels([]);
        }
        setPanelError('');
    };

    const handlePanelChange = (selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map(o => o.value) : [];
        setSelectedPanels(values);
        setSelectAll(values.length === panelOptions.length);
        setPanelError('');
    };

    // Every section has its own title, description and optional link
    const sectionRules = {};
    lessonDetails.forEach((_, index) => {
        sectionRules[`blog_title_${index}`] = yup.string().trim()
            .required('Please enter title')
            .max(255, 'Title must be at most 255 characters');
        sectionRules[`blog_link_${index}`] = yup.string().test('is-url', 'Invalid URL format', function (value) {
            if (!value) return true;
            const regex = /^(https?|http?):\/\/[^\s$.?#].[^\s]*$/;
            return regex.test(value);
        }).nullable().notRequired();
    });

    const schema = yup.object().shape({
        title: yup.string()
            .matches(/^[a-zA-Z\s]+$/, 'Please enter proper title')
            .required("Please enter title"),
        ...sectionRules,
        blog_description_0: yup.string()
            .required('Please enter description')
            .test('not-empty-content', 'Please enter description', (value) => {
                if (!value) return false;
                return value.replace(/<[^>]*>/g, '').trim().length > 0;
            })
    });

    const { register, handleSubmit, setValue, clearErrors, reset, watch, control, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            title: '',
            blog_title_0: '',
            blog_link_0: ''
        }
    });

    const handleImageChange = async (image, Attachment_Index, fileIndex, type) => {
        if (!image) {
            TOAST_ERROR("No file selected. Please select a valid file.");
            return;
        }
        TOAST_SUCCESS("Your attachment has been uploaded!");
        const str = "attachment_" + Attachment_Index;
        const temp_arr = { ...AttachmentData };
        isLoader(true);
        const image_name = await uploadImageOnAWS(image, "lesson_attachments");
        if (temp_arr[str]) {
            temp_arr[str][fileIndex] = { attachments: image_name, attachment_type: type };
        } else {
            temp_arr[str] = ["", "", "", "", "", ""];
            temp_arr[str][fileIndex] = { attachments: image_name, attachment_type: type };
        }

        setAttachmentData(temp_arr);
        isLoader(false);
    };

    const handleDescriptionChange = (index, value) => {
        setLessonDetails(prevDetails => {
            const updatedDetails = [...prevDetails];
            updatedDetails[index] = {
                ...updatedDetails[index],
                description: value
            };
            return updatedDetails;
        });
    };

    const handleSectionFieldChange = (index, field, value) => {
        setLessonDetails(prevDetails => {
            const updatedDetails = [...prevDetails];
            updatedDetails[index] = {
                ...updatedDetails[index],
                [field]: value
            };
            return updatedDetails;
        });
    };

    const handleAddDescription = () => {
        setLessonDetails([...lessonDetails, { title: '', description: '', link: '', attachment: null }]);
    };

    const handleDeleteAttachment = (attachmentKey, attachmentIndex) => {
        setAttachmentData((prevState) => {
            const updatedAttachmentData = { ...prevState };
            if (updatedAttachmentData[attachmentKey]) {
                updatedAttachmentData[attachmentKey] = updatedAttachmentData[attachmentKey].filter(
                    (_, idx) => idx !== attachmentIndex
                );
            }
            return updatedAttachmentData;
        });
    };

    const handleRemoveDescription = (index) => {
        setLessonDetails(prevDetails => {
            const updated = prevDetails.filter((_, i) => i !== index);
            const newValues = {};
            updated.forEach((item, ind) => {
                newValues[`blog_title_${ind}`] = item.title || '';
                newValues[`blog_description_${ind}`] = item.description || '';
                newValues[`blog_link_${ind}`] = item.link || '';
            });

            // Adjust AttachmentData keys to bubble up values
            setAttachmentData(prevAttach => {
                const newAttach = {};
                for (let i = 0; i < prevDetails.length; i++) {
                    if (i === index) continue;
                    const newIndex = i > index ? i - 1 : i;
                    if (prevAttach[`attachment_${i}`]) {
                        newAttach[`attachment_${newIndex}`] = prevAttach[`attachment_${i}`];
                    }
                }
                return newAttach;
            });

            setTimeout(() => {
                Object.keys(newValues).forEach(key => {
                    setValue(key, newValues[key]);
                });
            }, 10);

            return updated;
        });
    };

    // Main images/videos upload handlers. A blog carries one media item: a single image or a single video.
    const [mainImages, setMainImages] = useState([]);
    const [mainVideos, setMainVideos] = useState([]);
    const [mediaError, setMediaError] = useState('');
    const imageInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const BOTH_MEDIA_ERROR = "You can upload either one image or one video, not both. Please remove the image or the video.";

    const handleMainMediaChange = (e) => {
        const { name, files } = e.target;
        const fileArray = Array.from(files).slice(0, 1);

        if ((name === 'images' && fileArray.length && mainVideos.length) || (name === 'videos' && fileArray.length && mainImages.length)) {
            setMediaError(BOTH_MEDIA_ERROR);
            TOAST_ERROR(BOTH_MEDIA_ERROR);
            e.target.value = '';
            return;
        }
        setMediaError('');

        if (name === 'images') {
            setMainImages(fileArray);
            const imageUrls = fileArray.map(file => URL.createObjectURL(file));
            setPreviewImageUrls(imageUrls);
        } else if (name === 'videos') {
            setMainVideos(fileArray);
            const videoUrls = fileArray.map(file => URL.createObjectURL(file));
            setPreviewVideoUrls(videoUrls);
        }
    };

    const handleRemoveMainMedia = (name) => {
        if (name === 'images') {
            setMainImages([]);
            setPreviewImageUrls([]);
            if (imageInputRef.current) imageInputRef.current.value = '';
        } else {
            setMainVideos([]);
            setPreviewVideoUrls([]);
            if (videoInputRef.current) videoInputRef.current.value = '';
        }
        setMediaError('');
    };

    const onSubmit = async (data) => {
        if (selectedPanels.length === 0) {
            setPanelError('Please select at least one panel');
            return;
        }
        if (mainImages.length && mainVideos.length) {
            setMediaError(BOTH_MEDIA_ERROR);
            TOAST_ERROR(BOTH_MEDIA_ERROR);
            return;
        }
        isLoader(true);

        var media = [];
        // Upload main images
        if (mainImages && mainImages.length > 0) {
            for (const image of mainImages) {
                var blog_image = await uploadImageOnAWS(image, "blogs");
                media.push({ media_type: 'image', name: blog_image });
            }
        }
        // Upload main videos
        if (mainVideos && mainVideos.length > 0) {
            for (const video of mainVideos) {
                var blog_video = await uploadImageOnAWS(video, "blogs");
                media.push({ media_type: 'video', name: blog_video });
            }
        }

        var description_arr = lessonDetails.map((lesson, index) => {
            var temp_obj = {};
            var temp_str = `blog_description_${index}`;
            var attach_str = `attachment_${index}`;
            temp_obj.title = (data[`blog_title_${index}`] || '').trim();
            temp_obj.description = data[temp_str] || '';
            temp_obj.link = data[`blog_link_${index}`] || '';
            temp_obj.images = ''; // No Images Only editor output

            if (AttachmentData[attach_str]) {
                var originalArray = AttachmentData[attach_str];
                var newArray = originalArray.filter(item => item !== '');
                temp_obj.attachments = newArray;
            } else {
                temp_obj.attachments = [];
            }
            return temp_obj;
        });

        var obj = {
            title: data.title,
            admin_id: AdminId,
            media: media,
            blogdata: description_arr,
            panels: selectedPanels
        };

        const response = await add_blog(obj);
        if (response.code == 1) {
            TOAST_SUCCESS(response.message);
            navigate('/blog');
            isLoader(false);
        } else {
            TOAST_ERROR(response.message);
            isLoader(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>
                <div className="mx-5 mt-4 w-100">
                    <span onClick={handleBack} style={{ cursor: 'pointer' }}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>

                        <span className="ms-2">Back</span>
                    </span>
                    <p className="d-flex justify-content-center fs-3 fw-500"> Add Blog</p>
                    <div className="row align-items-center justify-content-center mt-5 mb-5">
                        <div className="col-lg-10">
                            <div className="card border-purple p-5" >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-4">
                                        <label htmlFor="title" className="form-label">Enter Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="title"
                                            placeholder="Enter title"
                                            {...register("title")}
                                        />
                                        {errors.title && (
                                            <div className="text-danger">{errors.title.message}</div>
                                        )}
                                    </div>

                                    {/* Panels Multi-Select */}
                                    <div className="mb-4">
                                        <label className="form-label">In which side you want to show this Blog:</label>
                                        {!selectAll && (
                                            <Select
                                                options={panelOptions}
                                                required
                                                value={panelOptions.filter(o => selectedPanels.includes(o.value))}
                                                className='mt-2'
                                                onChange={handlePanelChange}
                                                isSearchable={true}
                                                isMulti={true}
                                                placeholder="Select Panels..."
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        border: '1px solid rgba(102, 102, 102, 0.35)',
                                                        borderRadius: '12px',
                                                        padding: '5px 10px',
                                                        minHeight: '46px',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                    }),
                                                }}
                                            />
                                        )}
                                        {panelError && (
                                            <div className="text-danger mt-1">{panelError}</div>
                                        )}
                                        {selectAll && (
                                            <input
                                                type="text"
                                                className="form-control py-2 mt-2"
                                                placeholder="All are selected"
                                                readOnly
                                                style={{ borderRadius: "12px" }}
                                            />
                                        )}
                                        <div className="form-check mt-2">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="selectAllBlog"
                                                checked={selectAll}
                                                onChange={handleSelectAllChange}
                                            />
                                            <label className="form-check-label text-secondary" htmlFor="selectAllBlog">Select All Panels</label>
                                        </div>
                                    </div>

                                    {/* Multiple Description Blocks */}
                                    {lessonDetails.map((lesson, index) => (
                                        <div className={`${index !== 0 ? "border rounded mb-4 p-4 position-relative mt-4" : "mb-4 position-relative"}`} key={index}>

                                            {/* Sleek, Absolute-Positioned Overlapping Black Circle Close Button */}
                                            {index !== 0 && (
                                                <span
                                                    onClick={() => handleRemoveDescription(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-15px',
                                                        right: '-15px',
                                                        cursor: 'pointer',
                                                        width: '32px',
                                                        height: '32px',
                                                        backgroundColor: '#000000',
                                                        color: '#ffffff',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        zIndex: 10,
                                                        border: '2px solid #ffffff',
                                                        boxShadow: '0px 2px 5px rgba(0,0,0,0.2)'
                                                    }}
                                                    title="Remove Section"
                                                >
                                                    ×
                                                </span>
                                            )}

                                            <div className="form-group mb-4">
                                                <label className="form-label">Title</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={255}
                                                    placeholder="Enter title"
                                                    {...register(`blog_title_${index}`, {
                                                        onChange: (e) => handleSectionFieldChange(index, 'title', e.target.value)
                                                    })}
                                                />
                                                {errors[`blog_title_${index}`] && (
                                                    <div className="text-danger mt-1">{errors[`blog_title_${index}`].message}</div>
                                                )}
                                            </div>

                                            <div className="form-group mb-4">
                                                <label className="form-label">Description</label>
                                                <div className="position-relative">
                                                    <Controller
                                                        name={`blog_description_${index}`}
                                                        control={control}
                                                        defaultValue=""
                                                        render={({ field }) => (
                                                            <Editor
                                                                content={field.value}
                                                                onChange={(value) => {
                                                                    const isEmpty = value.replace(/<[^>]*>/g, '').trim() === '';
                                                                    const validated = isEmpty ? '' : value;
                                                                    field.onChange(validated);
                                                                    handleDescriptionChange(index, validated);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {errors[`blog_description_${index}`] && (
                                                        <div className="text-danger mt-1">
                                                            {errors[`blog_description_${index}`].message}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="form-group mb-4 attach_box">
                                                <label className="form-label">Attachments</label>
                                                <div className="position-relative">
                                                    <div className="textarea-wrapper" style={{ position: 'relative' }}>
                                                        <textarea
                                                            type="text"
                                                            className="form-control"
                                                            name={`attachments_text_${index}`}
                                                            rows={6}
                                                            readOnly
                                                            style={{ paddingBottom: '60px' }}
                                                        />
                                                        <div className="attachments-preview p-2" style={{
                                                            position: 'absolute',
                                                            top: 5,
                                                            left: 5,
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '5px',
                                                            zIndex: 4
                                                        }}>
                                                            {AttachmentData[`attachment_${index}`]?.map((item, idx) =>
                                                                item && item.attachments ? (
                                                                    <span key={idx} className="badge bg-light text-dark p-2 border d-flex align-items-center">
                                                                        {item.attachments.split('/').pop()}
                                                                        <button
                                                                            type="button"
                                                                            className="btn-close ms-2"
                                                                            style={{ fontSize: '10px' }}
                                                                            onClick={() => handleDeleteAttachment(`attachment_${index}`, idx)}
                                                                        >
                                                                        </button>
                                                                    </span>
                                                                ) : null
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* absolute-positioned attachment options at bottom right of the textarea */}
                                                    <div className="att_icon_list position-absolute" style={{ bottom: '15px', right: '15px', zIndex: 5 }}>
                                                        <ul className="d-flex align-items-center justify-content-start list-unstyled gap-3" style={{ padding: 0, margin: 0 }}>
                                                            <li>
                                                                <label htmlFor={`attach1_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach1.png" alt="attach1" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input
                                                                    type="file"
                                                                    id={`attach1_${index}`}
                                                                    onInput={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (!file) return;
                                                                        const fileType = file.type.startsWith('image')
                                                                            ? 'image'
                                                                            : file.type.startsWith('video')
                                                                                ? 'video'
                                                                                : file.type === 'application/pdf'
                                                                                    ? 'pdf'
                                                                                    : file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                                                                        ? 'docx'
                                                                                        : 'xlsx';
                                                                        handleImageChange(file, index, 0, fileType);
                                                                    }}
                                                                    accept="image/*,video/*,application/pdf,.docx,.xlsx"
                                                                    className="file-input"
                                                                    style={{ visibility: 'hidden', display: 'none' }}
                                                                />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach2_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach2.png" alt="attach2" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach2_${index}`} onInput={(e) => handleImageChange(e.target.files[0], index, 1, "video")} accept="video/*" className="file-input" style={{ visibility: "hidden", display: "none" }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach3_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach3.png" alt="attach3" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach3_${index}`} accept="image/*" onInput={(e) => handleImageChange(e.target.files[0], index, 2, "image")} className="file-input" style={{ visibility: "hidden", display: "none" }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach4_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach4.png" alt="attach4" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach4_${index}`} accept=".docx" onInput={(e) => handleImageChange(e.target.files[0], index, 3, "docx")} className="file-input" style={{ visibility: "hidden", display: "none" }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach5_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach5.png" alt="attach5" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach5_${index}`} onInput={(e) => handleImageChange(e.target.files[0], index, 4, "xlsx")} accept=".xlsx" className="file-input" style={{ visibility: "hidden", display: "none" }} />
                                                            </li>
                                                            <li>
                                                                <label htmlFor={`attach6_${index}`} style={{ margin: 0 }}>
                                                                    <a style={{
                                                                        cursor: 'pointer',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        boxShadow: '0px 3px 5px rgba(0,0,0,0.26)',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        borderRadius: '100%',
                                                                        backgroundColor: '#ffffff'
                                                                    }}>
                                                                        <img src="./assets/images/attach6.png" alt="attach6" style={{ width: '16px', height: '16px' }} />
                                                                    </a>
                                                                </label>
                                                                <input type="file" id={`attach6_${index}`} onInput={(e) => handleImageChange(e.target.files[0], index, 5, "pdf")} accept=".pdf" className="file-input" style={{ visibility: "hidden", display: "none" }} />
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group mb-2">
                                                <label className="form-label">Enter Link Or URL (Optional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter link"
                                                    {...register(`blog_link_${index}`, {
                                                        onChange: (e) => handleSectionFieldChange(index, 'link', e.target.value)
                                                    })}
                                                />
                                                {errors[`blog_link_${index}`] && (
                                                    <div className="text-danger mt-1">{errors[`blog_link_${index}`].message}</div>
                                                )}
                                            </div>
                                        </div>
                                    ))}

                                    {/* Action link styled perfectly with standard purple matching theme */}
                                    <div className="text-end mt-4">
                                        <a
                                            className="text-decoration-underline text-purple fw-bold font-15"
                                            style={{ cursor: 'pointer', color: '#570861' }}
                                            onClick={handleAddDescription}
                                        >
                                            + Add Another Title, Attachment and Description
                                        </a>
                                    </div>

                                    {/* Add Main Media Option */}
                                    <div className="row mb-5 mt-5">
                                        <div className="col-lg-6 mb-4 mb-lg-0">
                                            <div className="form-group">
                                                <label className="form-label">Add Cover Image</label>
                                                <div className="input-group">
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="images"
                                                        ref={imageInputRef}
                                                        accept="image/*"
                                                        onChange={handleMainMediaChange}
                                                    />
                                                </div>
                                                <div className="d-flex flex-wrap mt-3 gap-2">
                                                    {previewImageUrls.map((url, idx) => (
                                                        <div key={idx} style={{ position: "relative" }}>
                                                            <img
                                                                src={url}
                                                                alt="preview"
                                                                style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "8px" }}
                                                            />
                                                            <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0 py-0 px-1" onClick={() => handleRemoveMainMedia('images')}>&times;</button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label className="form-label">Add Cover Video</label>
                                                <div className="input-group">
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="videos"
                                                        ref={videoInputRef}
                                                        accept="video/*"
                                                        onChange={handleMainMediaChange}
                                                    />
                                                </div>
                                                <div className="d-flex flex-wrap mt-3 gap-2">
                                                    {previewVideoUrls.map((url, idx) => (
                                                        <div key={idx} style={{ position: "relative" }}>
                                                            <video
                                                                src={url}
                                                                style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "8px" }}
                                                                controls
                                                            />
                                                            <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0 py-0 px-1" onClick={() => handleRemoveMainMedia('videos')}>&times;</button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 mt-2">
                                            <small className="text-muted d-block">A blog can have one cover: either an image or a video.</small>
                                            {mediaError && <div className="text-danger mt-1">{mediaError}</div>}
                                        </div>
                                    </div>

                                    <div className="mt-5 d-flex justify-content-center align-items-center">
                                        <button type="submit" className="px-4 py-2 btn-theme bg-yellow text-center fw-600 d-block">
                                            Add Blog
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </>
}